import React from 'react';

import { QEmptyState } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

const EmergencyBreak: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div data-cy={'emergency-break'}>
      <QEmptyState title={t('emergencyBreak.title')} subtitle={t('emergencyBreak.subtitle')} />
    </div>
  );
};

export default EmergencyBreak;
